// extracted by mini-css-extract-plugin
export var container = "ProductContainer-module--container--3_Xlr";
export var containerFit = "ProductContainer-module--containerFit--2aUCE";